import * as React from 'react';
import './checkbox.styles.less';
import { getModeClass } from 'utils/css';

export default class Checkbox extends React.Component<ICheckboxProps> {
    public static defaultProps: Partial<ICheckboxProps> = {
        disabled: false
    };

    constructor(props: ICheckboxProps) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    private handleClick(e: React.SyntheticEvent) {
        e.preventDefault();
        if (!this.props.disabled) {
            if (this.props.onChange) {
                this.props.onChange(); 
            }
        }
    }

    public render(): JSX.Element {
        const { name, checked, label, shouldInheritStyles } = this.props;
        const basePageStyleClass = getModeClass('sitegen-checkbox', shouldInheritStyles);
        return (
            <div className={basePageStyleClass} onClick={this.handleClick} onTouchEnd={this.handleClick}>
                <label className={`${basePageStyleClass}__label`}>
                    <input className={`${basePageStyleClass}__hidden-input`}
                        type="checkbox"
                        name={name}
                        defaultChecked={checked}/>
                    <StyledCheckbox {...this.props}/>
                    <span className={`${basePageStyleClass}__label-text`}>{label}</span>
                </label>
            </div>
        );
    }
}

const StyledCheckbox: React.FC<Partial<ICheckboxProps>> = props => {
    const checkboxCheckedState: string = props.checked ? 'checked' : 'unchecked';
    const checkboxDisabledState: string = props.disabled ? 'disabled' : 'enabled';
    const basePageStyleClass = getModeClass('sitegen-checkbox', props.shouldInheritStyles);

    return (
        <div className={
            `${basePageStyleClass}__styled 
            ${basePageStyleClass}--${checkboxCheckedState} 
            ${basePageStyleClass}--${checkboxDisabledState}`}>
            <div className={`${basePageStyleClass}__checkmark`}/>
        </div>
    );
};

export interface ICheckboxProps {
    readonly disabled?: boolean;
    readonly checked?: boolean;
    readonly name?: string;
    readonly label?: string;
    readonly onChange?: () => void;
    readonly shouldInheritStyles?: boolean;
}
